import styles from './styles.module.scss';

import { ModuleStatus } from './types';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Agent } from '../../../components/Agent';
import { getModuleByProp } from '../../../modules/config/ModulesList';
import { useModule } from '../../../hooks/useModule';
import { NavButton } from '../../../components/NavButton';
import { Modal } from '../../../components/Modal';
import { PortugolWebStudio } from '../../../components/PortugolWebStudio';
import {
    handleTextVariables,
    hasPermission,
    verifyRoutePermissions
} from '../../../globalFunctions';
import moment from 'moment';
import { MessageBox } from '../../../components/MessageBox';
import $ from 'jquery';
import { Answer, Exercise, Feedback, LoadData, User } from '../../../types';
import { LoadingContext } from '../../../providers/LoadingProvider';
import { MessageContext } from '../../../providers/MessageProvider';
import { ExerciseLogProps } from './types';
import { createExerciseLog, saveExerciseChanges } from './requestHandlers';
import TrilogicUserManual from '../../../assets/files/trilogic_manual_do_usuario_v1.pdf';
import parabensDescricao from '../../../../src/assets/medals/parabens_descricao.png';
import parabensOperacoes from '../../../../src/assets/medals/parabens_operacoes.png';
import parabensVariaveis from '../../../../src/assets/medals/parabens_variaveis.png';
import parabensCondicionais from '../../../../src/assets/medals/parabens_condicionais.png';
import parabensLeituraEscrita from '../../../../src/assets/medals/parabens_leitura_escrita.png';
import parabensFluxograma from '../../../../src/assets/medals/parabens_fluxograma.png';
import parabensRepeticao from '../../../../src/assets/medals/parabens_repeticao.png';
import parabensVetores from '../../../../src/assets/medals/parabens_vetores.png';
import parabensLinguagemC from '../../../../src/assets/medals/parabens_vetores.png';
import parabensLinguagensInternet from '../../../../src/assets/medals/parabens_vetores.png';
import parabensPseudocodigo from '../../../../src/assets/medals/parabens_pseudocodigo.png';
import { Parabens } from '../../../components/Parabens';
import { loadModulesStatus } from './loadData';
import 'reactjs-popup/dist/index.css';
import { MenuAcessibilidade } from '../../../components/MenuAcessibilidade';
import { BotaoAcessibilidade } from '../../../components/BotaoAcessibilidade';
import { ThemeContext } from '../../../providers/ThemeProvider';
import { AlertDialog, AlertDialogType } from '../../../components/AlertDialog';
import axios from 'axios';
import { set } from 'lodash';

export const ModuleRoute = () => {
    const [userAuth, setUserAuth] = useState<User>({} as User);
    const { setIsLoadingPage } = useContext(LoadingContext);
    const [ParabensAtual, setParabensAtual] = useState<any>(parabensDescricao);
    const [personagem, setPersonagem] = useState();
    const navigate = useNavigate();

    // Exercise states
    const [modulesStatus, setModulesStatus] = useState<ModuleStatus[]>([]);
    const [completed, setCompleted] = useState(false);
    const [showMessageBox, setShowMessageBox] = useState<boolean>(true);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [showAcessibilidade, setShowMenu] = useState<boolean>(false);
    const [showPortugol, setShowPortugol] = useState<boolean>(false);
    // Loading exercise states
    const { moduleId } = useParams();
    const moduleIdNum = parseInt(moduleId || '1', 10);

    // só resolve o module quando modulesStatus já foi carregado
    const module =
        modulesStatus && modulesStatus.length > 0
            ? getModuleByProp(moduleIdNum, modulesStatus)
            : undefined;

    // useModule aceita slug undefined e retorna isLoading: true — assim evita requisição invalida
    const moduleData: LoadData = useModule(module?.slug);

    const [currentModule, setCurrentModule] = useState<any>(null);
    const [currentEx, setCurrentEx] = useState<number>(1);
    const [currentExercise, setCurrentExercise] = useState<Exercise>();

    // Game states
    const [start, setStart] = useState<boolean>(false);
    const [startTime, setStartTime] = useState<string>('');
    const [endTime, setEndTime] = useState<string>('');
    const [hits, setHits] = useState<number>(-1);
    const [misses, setMisses] = useState<number>(-1);
    const [isReloadingContent, setIsReloadingContent] = useState<boolean>(false);
    const [currentFeedback, setFeedback] = useState<string>('');
    const [acessivel, setAcessivel] = useState<boolean>(false);
    const [showParabens, setShowParabens] = useState<boolean>(false) // Estado para controlar a exibição do pop-up de Parabéns
    const { setOpenMessage, setMessage } = useContext(MessageContext);
    const [alertDialogProps, setAlertDialogProps] = useState<AlertDialogType>();

    const showUserManual = () => {
        window.open(TrilogicUserManual);
    };

    const ModoAcessivel = () => {
        setAcessivel(!acessivel);
    };

    const showMenuAcessibilidade = () => {
        setShowMenu(!showMenuAcessibilidade);
    };
    console.log(modulesStatus);
    console.log(module);
    const sortFeedback = (type: 'CORRECT' | 'INCORRECT') => {
        let min = 0;
        let max = currentModule.feedbacks[type].length - 1;
        let sortedNumber = Math.floor(Math.random() * (max - min + 1) + min); // The maximum is inclusive and the minimum is inclusive
        let message = currentModule.feedbacks[type][sortedNumber].message;

        setFeedback(message);
    };

    const handleLoadModulesStatus = async () => {
        setIsLoadingPage(true);

        const result = await loadModulesStatus(userAuth.token, navigate);

        if (result && typeof result === 'object' && !Object.keys(result).includes('error')) {
            setModulesStatus(result.modules as ModuleStatus[]);
        } else {
            const error = result as Error;

            setMessage({
                type: 'error',
                content: error.message
            });
            setOpenMessage(true);
        }

        setIsLoadingPage(false);
    };

    const buildExerciseLog = async () => {
        const timeDifferenceInSeconds = moment(endTime, 'HH:mm:ss').diff(
            moment(startTime, 'HH:mm:ss'),
            'seconds'
        );

        const timeDifferenceFormatted = moment
            .utc(timeDifferenceInSeconds * 1000)
            .format('HH:mm:ss');

        const log = {
            FK_user_id: userAuth.id,
            FK_exercise_id: currentExercise?.id,
            date: moment().format(),
            time: timeDifferenceFormatted,
            hits: hits,
            misses: misses
        } as ExerciseLogProps;

        const result = await createExerciseLog(userAuth.token, navigate, log);

        if (result && typeof result === 'object' && Object.keys(result).includes('error')) {
            const error = result as Error;

            setMessage({
                type: 'error',
                content: error.message
            });
            setOpenMessage(true);
        }
    };

    const countDragBoxesLeft = () => {
        return $('.dragBoxContainer .dragBoxItem').length;
    };

    const checkIfIsFinished = (answers: Answer[], alternativas: any) => {
        let condition: boolean;

        condition = countDragBoxesLeft() === 0;

        if (condition) {
            let fullFilled = true;

            return fullFilled;
        } else {
            return false;
        }
    };

    const checkAnswers = (value: boolean, answers: Answer[]) => {
        let numberOfAnswers = 0;

        answers.forEach(answer => {
            if (answer && answer.isInCorrectDropBox === value) numberOfAnswers++;
        });

        return numberOfAnswers;
    };

    const handleConfirmParabens = (nextModuleId: number | null) => {
        setShowParabens(false); // Fecha o pop-up de parabéns
        if (!nextModuleId) {
            navigate('/');
        } else {
            navigate(`/module/${nextModuleId}`);
            setIsLoadingPage(true);
            setCurrentEx(1);
        }
    };

    const goForwards = () => {
        if (moduleData.isLoading) return;

        sessionStorage.clear();

        if (currentExercise && misses === 0) {
            currentExercise.isDoneByUser = true;
        }

        // Verifica se ainda há exercícios no módulo atual
        if (currentEx < currentModule.exAmount) {
            // Se sim, apenas avança o exercício
            setCurrentExercise(undefined);
            setCurrentEx(currentEx + 1);
            return;
        }

        // --- Lógica de Conclusão de Módulo ---

        const modules = Array.isArray(modulesStatus) ? modulesStatus.slice() : [];

        if (!modules || modules.length === 0) {
            navigate('/');
            return;
        }

        modules.sort((a, b) => {
            if (a.sort === b.sort) return (a.id || 0) - (b.id || 0);
            return (a.sort || 0) - (b.sort || 0);
        });

        const currentIndex = modules.findIndex(m => m.id === module.id);

        const safeIndex =
            currentIndex >= 0 ? currentIndex : modules.findIndex(m => m.slug === module.slug);
        const idx = safeIndex >= 0 ? safeIndex : 0;

        const nextIndex = (idx + 1) % modules.length;
        const nextModule = modules[nextIndex];

        setCurrentExercise(undefined);
        setCompleted(true); // Marca o módulo como concluído

        // Encontra o status do módulo atual
        const currentModuleStatus = modulesStatus.find(m => m.id === module.id);

        // Verifica se o módulo atual está completo (nova lógica)
        if (currentModuleStatus && !currentModuleStatus.isCompleted) {
            // Se o módulo não estava marcado como completo, mostra o pop-up de Parabéns
            setShowParabens(true);

            // A navegação para o próximo módulo será feita dentro de `handleConfirmParabens`
            // que será passada como prop para o componente `Parabens`.
            
            // Aqui, precisamos identificar o ID do próximo módulo para passar para `Parabens`
            const nextModuleId = nextModule ? nextModule.id : null;
            // setCompleted(true) foi movido para fora do if para garantir que o estado de "concluído"
            // seja atualizado antes de mostrar o parabéns (se necessário),
            // mas a navegação só acontece após o clique em "Confirmar".
            
            // Para garantir que o Parabens saiba para onde ir:
            // Precisamos atualizar a definição do componente Parabens para aceitar uma prop de callback
            // com a ID do próximo módulo.
            
            return; // Interrompe a função aqui para esperar o clique no Parabens
        }
        
        // Se já estava completo ou se a lógica não o marcou como concluído por algum motivo
        // (embora a lógica acima deva funcionar), ou se é o último módulo e está completo:
        const targetModuleId = nextModule ? nextModule.id : null;
        if (!targetModuleId) {
            navigate('/');
        } else {
            navigate(`/module/${targetModuleId}`);
        }

        setIsLoadingPage(true);
        setCurrentEx(1);
    };

    const goBackwards = () => {
        if (moduleData.isLoading) {
            return;
        }

        sessionStorage.clear();
        clearExercise();

        if (currentEx === 1) {
            navigate('/');
        } else {
            setCurrentExercise(undefined);
            setCurrentEx(currentEx - 1);
        }
    };

    const clearExercise = () => {
        setStart(false);
        setHits(-1);
        setMisses(-1);
    };

    useEffect(() => {
        if (start) {
            setStartTime(moment().format('HH:mm:ss'));
        }
    }, [start]);

    useEffect(() => {
        if (endTime) {
            buildExerciseLog();
            setShowMessageBox(true);
        }
    }, [endTime]);

    useEffect(() => {
        // Redefine a exibição do Parabéns ao mudar de módulo ou exercício
        setShowParabens(false); 
        
        if (currentEx === 1) {
            setShowModal(true);
        }

        if (!moduleData.isLoading && currentModule) {
            switch (module.sort) {
                case 1:
                    setParabensAtual(parabensDescricao);
                    break;

                case 2:
                    setParabensAtual(parabensFluxograma);
                    break;

                case 3:
                    setParabensAtual(parabensVariaveis);
                    break;

                case 4:
                    setParabensAtual(parabensOperacoes);
                    break;

                case 5:
                    setParabensAtual(parabensLeituraEscrita);
                    break;

                case 6:
                    setParabensAtual(parabensCondicionais);
                    break;

                case 7:
                    setParabensAtual(parabensRepeticao);
                    break;

                case 8:
                    setParabensAtual(parabensVetores);
                    break;

                case 10:
                    setParabensAtual(parabensPseudocodigo);
                    break;
                case 11:
                    setParabensAtual(parabensLinguagemC);
                    break;

                case 12:
                    setParabensAtual(parabensLinguagensInternet);
                    break;

                default:
                    setParabensAtual(parabensPseudocodigo);
                    break;
            }

            if (currentEx === 1) {
                setShowModal(true);
            }

            setCurrentExercise(currentModule.exercises[currentEx]);
            setShowMessageBox(true);
            clearExercise();
            setIsLoadingPage(false);
        }
    }, [currentEx, moduleData.isLoading]); // Adicionado moduleData.isLoading como dependência

    useEffect(() => {
        if (!moduleData.isLoading) {
            const data = Object.assign({}, moduleData.data);

            if (!data.exercises) {
                return;
            }

            if (data && typeof data === 'object' && !Object.keys(data).includes('error')) {
                for (const sort of Object.keys(data.exercises) as string[]) {
                    data.exercises[sort].description = handleTextVariables(
                        data.exercises[sort].description,
                        [
                            {
                                variable: '{nome}',
                                value: userAuth.name ?? 'Aluno(a)'
                            }
                        ]
                    );
                }

                for (const type of Object.keys(data.feedbacks) as string[]) {
                    for (const feedback of data.feedbacks[type] as Feedback[]) {
                        feedback.message = handleTextVariables(feedback.message, [
                            {
                                variable: '{nome}',
                                value: userAuth.name ?? 'Aluno(a)'
                            }
                        ]);
                    }
                }

                setCurrentExercise(data.exercises[currentEx]);
            } else {
                const error = data as Error;

                setMessage({
                    type: 'error',
                    content: error.message
                });
                setOpenMessage(true);
            }

            setCurrentModule(data);
            setIsLoadingPage(false);
        }
    }, [moduleData.isLoading, modulesStatus]);

    useEffect(() => {
        if (userAuth.token) {
            handleLoadModulesStatus();
        }
        handleCharacter();
    }, [userAuth]);

    useEffect(() => {
        sessionStorage.clear();
        setIsLoadingPage(true);

        const user = verifyRoutePermissions(['auth', 'email.verified'], navigate);

        if (typeof user === 'object') {
            setUserAuth(user);
        }
    }, []);

    const handleCharacter = async () => {
        var result;
        try {
            result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/personagem/user`, {
                userId: userAuth.id
            });
            console.log(result);
            setPersonagem(result.data);
            if (result.data == '') {
                navigate('/characterMaker');
            }
        } catch (error) {
            const response = {
                message: 'Erro ao buscar status dos módulos',
                error: error
            };

            return response;
        }
    };

    const editarFase = () => {
        sessionStorage.setItem('jsonEditar', JSON.stringify(currentExercise));
        sessionStorage.setItem('action', 'edit');
        sessionStorage.setItem('moduleId', moduleId?.toString() || '1');
        navigate('/manager/editor');
    };

    const publicarExercicio = async () => {
        setOpenMessage(true);
        if (currentExercise && currentExercise.id) {
            try {
                const success = await saveExerciseChanges(
                    userAuth.token,
                    { id: currentExercise.id, is_active: true },
                    navigate
                );
                if (success) {
                    setMessage({
                        type: 'success',
                        content: 'Exercicio publicado: '
                    });
                    setCurrentExercise({ ...currentExercise, is_active: true });
                } else {
                    setMessage({
                        type: 'error',
                        content: 'erro ao publicar exercicio'
                    });
                }
            } catch {}
        }
    };

    const PrivarExercicio = async () => {
        if (currentExercise && currentExercise.id) {
            setOpenMessage(true);
            try {
                const success = await saveExerciseChanges(
                    userAuth.token,
                    { id: currentExercise.id, is_active: false },
                    navigate
                );
                if (success) {
                    setMessage({
                        type: 'success',
                        content: 'Exercicio privado: '
                    });
                    setCurrentExercise({ ...currentExercise, is_active: false });
                } else {
                    setMessage({
                        type: 'error',
                        content: 'erro ao privar exercicio'
                    });
                }
            } catch {}
        }
    };

    console.log(currentExercise);

    const modulesSorted = Array.isArray(modulesStatus) ? [...modulesStatus].sort((a, b) => {
        if (a.sort === b.sort) return (a.id || 0) - (b.id || 0);
        return (a.sort || 0) - (b.sort || 0);
    }) : [];

    const currentIndex = modulesSorted.findIndex(m => m.id === module?.id);
    const nextModule = currentIndex !== -1 ? modulesSorted[(currentIndex + 1) % modulesSorted.length] : null;
    const nextModuleId = nextModule ? nextModule.id : null;


    return (
        <>
            {/* 1. Componente Parabens - Exibir condicionalmente e passar a função de fechar/avançar */}
            {showParabens && (
                <Parabens
                    module={module}
                    // Passa a função que fecha o pop-up e navega/recarrega
                    goForwards={() => handleConfirmParabens(nextModuleId)}
                />
            )}

            <div className={styles.wrapper}>
                {userAuth.token && currentExercise && !moduleData.isLoading && currentModule && (
                    <>
                        {(currentExercise.isDoneByUser ||
                            hasPermission('trilogic.admin', userAuth)) && (
                            <>
                                <NavButton
                                    direction='right'
                                    style={{ right: '1vw', top: '2vw', zIndex: '20' }}
                                    onClick={goForwards}
                                />
                            </>
                        )}

                        {hasPermission('trilogic.admin', userAuth) && (
                            <NavButton
                                icon='construction'
                                style={{ right: '1vw', top: '40vh', zIndex: '20' }}
                                onClick={editarFase}
                                title='Editar fase'
                            />
                        )}
                        {hasPermission('trilogic.admin', userAuth) &&
                            (currentExercise.is_active ? (
                                <NavButton
                                    icon='lock'
                                    style={{ left: '1vw', top: '30vh', zIndex: '20' }}
                                    onClick={PrivarExercicio}
                                    title='Privar fase'
                                />
                            ) : (
                                <NavButton
                                    icon='upload'
                                    style={{ left: '1vw', top: '30vh', zIndex: '20' }}
                                    onClick={publicarExercicio}
                                    title='Publicar fase'
                                />
                            ))}
                        <NavButton
                            icon='code'
                            style={{ right: '1vw', top: '10vw', zIndex: '20' }}
                            onClick={() => setShowPortugol(current => !current)}
                            title='Abrir Portugol Web'
                        />

                        <NavButton
                            icon='info'
                            style={{
                                right: '1vw',
                                top: '6vw',
                                zIndex: '20'
                            }}
                            onClick={() => setShowModal(current => !current)}
                            title='Mostrar modal'
                        />

                        {showAcessibilidade && (
                            <MenuAcessibilidade
                                ModoAcessivel={ModoAcessivel}
                                OnPress={showMenuAcessibilidade}
                                acessivel={acessivel}
                            />
                        )}
                        <NavButton
                            icon='home'
                            style={{ left: '1vw', top: '6vw', zIndex: '20' }}
                            route='/'
                        />

                        <NavButton
                            direction='left'
                            style={{ left: '1vw', top: '2vw', zIndex: '20' }}
                            onClick={goBackwards}
                        />
                        <NavButton
                            icon='quick_reference_all'
                            style={{ right: '1vw', bottom: '2vh', zIndex: '20' }}
                            onClick={showUserManual}
                            title='Mostrar manual'
                        />
                        {module.element({
                            currentEx,
                            maxEx: currentModule.exAmount,
                            currentExJson: currentExercise.json,
                            setEndTime: setEndTime,
                            setHits: setHits,
                            setMisses: setMisses,
                            checkIfIsFinished: checkIfIsFinished,
                            checkAnswers: checkAnswers,
                            isReloadingContent: isReloadingContent,
                            sortFeedback: sortFeedback,
                            acessivel: acessivel
                        })}
                        <Modal
                            content={currentModule.modal}
                            showModal={showModal}
                            onPress={() => setShowModal(current => !current)}
                        />
                        <BotaoAcessibilidade clicar={() => setShowMenu(current => !current)} />
                        <PortugolWebStudio
                            content={currentModule.modal}
                            showModal={showPortugol}
                            onPress={() => setShowPortugol(current => !current)}
                        />
                        {misses === 0 && (
                            <MessageBox
                                content={currentFeedback}
                                showMessageBox={showMessageBox}
                                onPress={() => {
                                    goForwards();
                                    setShowMessageBox(current => !current);
                                }}
                            />
                        )}
                        {misses > 0 && (
                            <MessageBox
                                content={currentFeedback}
                                showMessageBox={showMessageBox}
                                onPress={() => {
                                    setShowMessageBox(showMessageBox => !showMessageBox);
                                    setIsReloadingContent(true);
                                    clearExercise();

                                    setTimeout(() => {
                                        setIsReloadingContent(false);
                                        setStart(true);
                                    }, 1000);
                                }}
                            />
                        )}
                        {misses < 0 && (
                            <MessageBox
                                content={currentExercise.description || ''}
                                showMessageBox={showMessageBox}
                                onPress={() => {
                                    setStart(current => !current);
                                    setShowMessageBox(current => !current);
                                }}
                            />
                        )}
                        <Agent className={styles.agent} setShowMessageBox={setShowMessageBox} />
                    </>
                )}
            </div>
        </>
    );
};